import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { AppShell } from "../components/layout/AppShell";
import { useNavItems } from "../components/layout/useNavItems";
import { useApprovalsCount } from "../hooks/useApprovalsCount";
import { tileIconColor } from "../features/attendance/quickTileColors";

// صفحة «المزيد»: تضم كل الاختصارات المتاحة للدور + الإعدادات في مكان واحد.
export default function MorePage() {
  const { t } = useTranslation();
  const { allowed, bottom } = useNavItems();
  const approvals = useApprovalsCount();
  const inBar = new Set(bottom.map((i) => i.key));
  const items = allowed.filter((i) => i.key !== "home" && i.key !== "more" && !inBar.has(i.key));

  return (
    <AppShell title={t("nav.more")}>
      <div className="mx-auto w-full max-w-3xl" data-testid="more-page">
        <div className="grid grid-cols-4 gap-2.5 sm:gap-3">
          {items.map(({ to, key, icon: Icon }, index) => (
            <Link
              key={to}
              to={to}
              data-testid={`more-${key}`}
              style={{ animationDelay: `${index * 30}ms` }}
              className="group animate-rise-in relative flex aspect-square flex-col items-center justify-center gap-2 rounded-[1.5rem] bg-background p-2 text-center shadow-neu transition-[box-shadow,transform] duration-300 hover:-translate-y-1 active:translate-y-0 active:shadow-neu-in"
            >
              <span className={`relative flex h-14 w-14 shrink-0 items-center justify-center rounded-full text-white ring-1 ring-white/40 transition-transform duration-300 group-hover:scale-105 ${tileIconColor(key)}`}
                    style={{ boxShadow: "inset 0 2px 3px rgba(255,255,255,0.55), inset 0 -4px 6px rgba(0,0,0,0.22), 0 9px 18px rgba(0,0,0,0.22)" }}>
                <Icon className="h-7 w-7 drop-shadow-[0_1px_1px_rgba(0,0,0,0.25)]" strokeWidth={2.4} />
                {key === "requests" && approvals > 0 ? (
                  <span data-testid="more-approvals-badge" className="absolute -top-1 -right-1 inline-flex min-w-[18px] items-center justify-center rounded-full bg-destructive px-1 text-[10px] font-black text-white shadow-neu-sm">
                    {approvals}
                  </span>
                ) : null}
              </span>
              <span className="w-full text-[11px] font-black leading-tight line-clamp-2 text-foreground/80">{t(`nav.${key}`)}</span>
            </Link>
          ))}
        </div>
      </div>
    </AppShell>
  );
}
